module.exports = __webpack_public_path__ + "static/img/purchase.583e8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/purchase.png
// module id = Ss5z
// module chunks = 58